// Helpers for "Install to Home Screen" — detect platform, store the deferred prompt, and indicate if already installed.

export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const detectPlatform = () => {
  if (typeof window === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
};

// Capture the beforeinstallprompt event so we can trigger it from the UI later
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((cb) => cb(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((cb) => cb(false));
  });
}

export const canTriggerNativePrompt = () => deferredPrompt !== null;

export const triggerNativePrompt = async () => {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((cb) => cb(false));
  return choice.outcome; // 'accepted' | 'dismissed'
};

export const onPromptAvailabilityChange = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
